'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const SvgVeg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#Veg16_svg__clip0_32982_71547)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 14.6C6.0748 14.6 4.77174 14.597 3.79746 14.466C2.86345 14.3405 2.44383 14.1208 2.16152 13.8385C1.87921 13.5562 1.65954 13.1366 1.53396 12.2025C1.40297 11.2283 1.4 9.9252 1.4 8C1.4 6.0748 1.40297 4.77174 1.53396 3.79746C1.65954 2.86345 1.87921 2.44383 2.16152 2.16152C2.44383 1.87921 2.86345 1.65954 3.79746 1.53396C4.77174 1.40297 6.0748 1.4 8 1.4C9.9252 1.4 11.2283 1.40297 12.2025 1.53396C13.1366 1.65954 13.5562 1.87921 13.8385 2.16152C14.1208 2.44383 14.3405 2.86345 14.466 3.79746C14.597 4.77174 14.6 6.0748 14.6 8C14.6 9.9252 14.597 11.2283 14.466 12.2025C14.3405 13.1366 14.1208 13.5562 13.8385 13.8385C13.5562 14.1208 13.1366 14.3405 12.2025 14.466C11.2283 14.597 9.9252 14.6 8 14.6ZM0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0C11.7712 0 13.6569 0 14.8284 1.17157C16 2.34315 16 4.22876 16 8C16 11.7712 16 13.6569 14.8284 14.8284C13.6569 16 11.7712 16 8 16C4.22876 16 2.34315 16 1.17157 14.8284C0 13.6569 0 11.7712 0 8ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z", fill: "#0F8A65" })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "Veg16_svg__clip0_32982_71547" },
            React__namespace.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(16 16) rotate(-180)" })))));

exports.default = SvgVeg16;
//# sourceMappingURL=Veg16.js.map
